import { CONFIG } from 'src/global-config';

export const _offices = [
  {
    id: 'o1',
    country: 'Saudi Arabia',
    email: 'info@shahen-sa.com',
    photoUrl: `${CONFIG.assetsDir}/assets/images/home/offices/riyadh-transport-company-location.webp`,
    altText: 'Location of our freight transport company in Riyadh',
    address: 'Riyadh – Al Sulaymaniyah District – Eng. Musaad Al Anqari St',
    phoneNumber: '920012163',
    position: { lat: 24.71600077991534, lng: 46.68273080647215 },
  },
];
